import {merge} from "lodash";
import partnerMessages from "@i18n_messages_cs"

export default merge({}, partnerMessages);